import { render, staticRenderFns } from "./RestartChatbotConfirmationModal.vue?vue&type=template&id=6310d17c&scoped=true&"
import script from "./RestartChatbotConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./RestartChatbotConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./RestartChatbotConfirmationModal.vue?vue&type=style&index=0&id=6310d17c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6310d17c",
  null
  
)

export default component.exports